import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-survey-merge-modal',
  templateUrl: './survey-merge-modal.component.html',
  styleUrls: ['./survey-merge-modal.component.scss']
})
export class SurveyMergeModalComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<SurveyMergeModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
  }

  noDelete(): void {
    this.dialogRef.close({delete: false});
  }

  delete(): void {
    this.dialogRef.close({delete: true});
  }

}
